export default {
	section_banner: {
		title: {
			one: '取得',
		},
		main_title: {
			one: '開始しました',
		},
		sub_title: {
			one: 'Aのように',
			two: '銀行',
		},
		paragraph: {
			one: 'すべてはビジネスアカウントから始まります。JPWorldPayを活用してビジネスの成長と管理を行っている3,000万人以上のセラーに加わりましょう。',
		},
		cta_buttons: {
			one: 'Contact Now',
			two: 'Download App',
		},
	},

	credit_system: {
		label: '最速の支払いシステム',
		title: {
			one: '始める',
			two: '支払い',
		},
		paragraph: {
			one: 'メールアドレスと会社名を確認し、JPWorldPayアカウントをリンクすると、最初の販売準備が完了します。この簡単な設定プロセスで、迅速かつ安全に支払いを受け付ける準備が整います。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	creditcard_system_inn: {
		label: '簡単な手順',
		title: {
			one: '無料',
			two: '登録',
		},
		paragraph:
			'必要なのはメールアドレスとビジネスに関する基本情報だけです。登録は素早く簡単で、すぐに支払いの受け取りと財務管理を始めることができます。JPWorldPayは、ビジネスのオンボーディングをスムーズかつ安全、そしてストレスフリーに行えるように設計されています。',
		cta_buttons: {
			one: '一緒に参加しましょう',
		},
	},

	get_touch_sec: {
		label: '簡単設定',
		title: {
			one: '得る',
			two: '連絡中',
		},
		paragraph:
			'お問い合わせ。私たちがお手伝いいたします。アカウントに関するご質問、お取引に関するサポート、JPWorldPayの機能について詳しく知りたいなど、どんなことでもサポートチームがお手伝いいたします。いつでもお気軽にお問い合わせください。迅速かつ的確なサービスを提供し、スムーズで安心なご利用体験をお届けできるよう尽力して​​おります。専門家による的確なアドバイスとサポートで、常にお客様をサポ​​ートいたします。',
		cta_buttons: {
			one: '私たちとつながりましょう',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
